import { type FC } from "react";
import { Button } from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";

interface TeamFilterProps {
  onInvite: () => void;
}

export const TeamFilter: FC<TeamFilterProps> = ({ onInvite }) => {
  const { t } = useTranslation();

  return (
    <Filter
      title={t("team.pageTitle")}
      action={
        <Button
          variant="contained"
          color="primary"
          startIcon={<PersonAddIcon />}
          disableElevation
          onClick={onInvite}
        >
          {t("team.invite.submit")}
        </Button>
      }
      selects={[
        {
          name: "disabled",
          label: t("team.filter.statusLabel"),
          options: [
            { value: "false", label: t("team.filter.status.active") },
            { value: "true", label: t("team.filter.status.disabled") },
          ],
        },
      ]}
      fields={{
        search: true,
      }}
    />
  );
};
